<template>
    <PageShell :title="$t('interface.title.exportChannels')">
      <ChannelGrid :channels="channels" />
    </PageShell>
  </template>
  
  <script>
  import ChannelGrid from './components/ChannelGrid.vue'; 
  import PageShell from './components/PageShell.vue';
  import { resolveDataUrl } from './utils/dataResolver';
  
  export default {
    components: {
      ChannelGrid,
      PageShell
    },
    data() {
      return {
        channels: [] // 存储渠道数据
      };
    },
    async mounted() {
        try {
            const response = await fetch(resolveDataUrl('data/launch.json')); 
            if (!response.ok) {
                throw new Error('Failed to load launch.json');
            }
            // 读取响应体为 JSON
            const jsonData = await response.json(); // 直接解析为 JSON
            this.channels = jsonData; // 将数据赋值给 channels

        } catch (error) {
            console.error('加载 launch.json 时出错:', error); // 日志：错误信息
        }
    }
};
  </script>

  <style scoped>
  /* 页面级样式已全部收敛到 PageShell / SiteTitle / cards.css，此处无需额外规则 */
  </style>